import { z } from '@kc3/validation';
export const PciPauseEventSchema = z.object({
    tenantSlug: z.string(),
    callId: z.string().uuid().or(z.string().length(0)),
    channelId: z.string(),
    bridgeId: z.string().optional(),
    agentId: z.string(),
    timestamp: z.string().datetime(),
});
export const PciPauseFailedEventSchema = z.object({
    tenantSlug: z.string(),
    callId: z.string(),
    agentId: z.string(),
    status: z.literal('FAILED'),
    message: z.string(),
    timestamp: z.string().datetime(),
});
//# sourceMappingURL=pci-pause.js.map